<template>
	<div class="Grad3Prefight">
		<div class="container">
			<h1>
				{{
					$t('navigationAusbildungsgrade.grade.grad3.lesson1.readMore.title')
				}}
			</h1>
			<div class="row align-items-center">
				<div class="py-5 col-9">
					<div class="mb-5">
						{{
							$t(
								'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.description.absatz1'
							)
						}}
						<router-link :to="{ name: 'Grad1Prefight' }">{{
							$t(
								'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.description.absatz1a'
							)
						}}</router-link>
						{{
							$t(
								'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.description.absatz1b'
							)
						}}
						<router-link :to="{ name: 'Grad2Prefight' }">{{
							$t(
								'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.description.absatz1c'
							)
						}}</router-link>
						{{
							$t(
								'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.description.absatz1d'
							)
						}}
					</div>
					<div class="mb-3">
						{{
							$t(
								'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.description.absatz2'
							)
						}}
					</div>
					<ul class="mb-5">
						<li>
							{{
								$t(
									'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.learnings.learning1'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.learnings.learning2'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.learnings.learning3'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.learnings.learning4'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.learnings.learning5'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.learnings.learning6'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.learnings.learning7'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.learnings.learning8'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.learnings.learning9'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.learnings.learning10'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.learnings.learning11'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.learnings.learning12'
								)
							}}
						</li>
						<li>
							{{
								$t(
									'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.learnings.learning13'
								)
							}}
						</li>
					</ul>
					<div class="mb-3">
						{{
							$t(
								'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.note.absatz1'
							)
						}}
						<router-link :to="{ name: 'Grad2Prefight' }">{{
							$t(
								'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.note.absatz1a'
							)
						}}</router-link>
						{{
							$t(
								'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.note.absatz1b'
							)
						}}
					</div>
					<div class="mb-3">
						{{
							$t(
								'navigationAusbildungsgrade.grade.grad3.lesson1.readMore.note.absatz2'
							)
						}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import systemMixin from '@/views/system/systemMixin.js'

export default {
	name: 'Grad3Prefight',
	mixins: [systemMixin]
}
</script>
